import Vue from 'vue'

import Render from '@/components/Render'
import DatePicker from '@/components/ui/DatePicker'
import SelectBox from '@/components/ui/SelectBox'
import TextBox from '@/components/ui/TextBox'
import Textarea from '@/components/ui/Textarea'
import vSelect from 'vue-select'
// import LookUp from '@/components/ui/LookUp'

const loadingInstance = new Vue({
  data: {
    isShow: false,
    isWhite: false
  },
  methods: {
    show (white) {
      this.isShow = true
      if (white) {
        this.isWhite = true
      }
    },
    hide () {
      this.isShow = false
      this.isWhite = false
    }
  }
})

export default {
  install (Vue) {
    Vue.prototype.$loading = loadingInstance
    Vue.component('Render', Render)
    Vue.component('DatePicker', DatePicker)
    Vue.component('SelectBox', SelectBox)
    Vue.component('TextBox', TextBox)
    Vue.component('Textarea', Textarea)
    Vue.component('LookUp', vSelect)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/core-components.js